<ui-card>
    <app-segment-header title="time-off-v3.policyComponents.maximumAccruedBalance.header"> </app-segment-header>

    <div>
        <mat-checkbox
            name="maxBalanceCap"
            type="checkbox"
            [(ngModel)]="showMaxBalanceCap"
            (change)="onMaxBalanceCapChange()"
        >
            <span class="limit-label">{{
                'time-off-v3.policyComponents.maximumAccruedBalance.limitMaximumAccruedBalance' | translate
            }}</span>
        </mat-checkbox>

        <div class="period-input">
            <span>{{
                'time-off-v3.policyComponents.maximumAccruedBalance.employeesCannotHaveGreaterBalance' | translate
            }}</span>
            <mat-form-field>
                <input
                    [textMask]="{ mask: numberMask }"
                    [min]="0"
                    [ngModel]="timeOffPolicy.getLocalizedProperty('balanceCap')"
                    (ngModelChange)="timeOffPolicy.setLocalizedProperty('balanceCap', $event)"
                    name="maxCapAt"
                    #maxCapAt="ngModel"
                    [placeholder]="('0.00' | i18nNum) ?? ''"
                    required
                    matInput
                    [disabled]="!showMaxBalanceCap"
                />
                <span matSuffix>{{ timeOffPolicy.timeOffType.unitOfTimePlural | translate | lowercase }}</span>
                <mat-error *ngIf="maxCapAt.invalid">{{ maxCapAt.errors | formErrors }}</mat-error>
            </mat-form-field>
            <span>{{ 'time-off-v3.policyComponents.maximumAccruedBalance.atAnyTime' | translate }}</span>
        </div>
    </div>
</ui-card>
